import React from 'react';
import { Clock, ArrowLeft } from "lucide-react";
import { getStatusName, getStatusColor, getStatusDescription } from '../../utils/statusUtils';

const styles = {
    primaryColor: '#F76707',
    secondaryColor: '#0A6EBD',
    lightOrange: '#FFF4E6',
};

const TrackingHeader = ({ status, onBack, trackingNumber }) => {
    // Obtenir la couleur du statut à partir des utilitaires
    const statusColor = status ? getStatusColor(status) : styles.primaryColor;
    const statusName = status ? getStatusName(status) : 'Statut inconnu';
    const statusDescription = status ? getStatusDescription(status) : '';

    // Déterminer si la couleur du texte doit être claire ou foncée
    // Pour les couleurs claires (jaune, orange), utiliser du texte foncé
    const textColor = ["#ffc107", "#fd7e14"].includes(statusColor) ? "#212529" : "#ffffff";

    return (
        <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center gap-2">
                    <h2 className="mb-0">Statut de votre réclamation</h2>
                    <Clock style={{ color: styles.primaryColor }} />
                </div>
                <div className="d-flex align-items-center">
                    {trackingNumber && (
                        <div className="small me-3 text-muted">
                            Numéro de suivi: <strong>{trackingNumber}</strong>
                        </div>
                    )}
                    <button
                        className="btn btn-link"
                        onClick={onBack}
                        style={{ color: styles.secondaryColor }}
                    >
                        <ArrowLeft size={16} className="me-1" />
                        Nouvelle recherche
                    </button>
                </div>
            </div>

            {/* Badge de statut avec la couleur correspondante */}
            <div
                className="alert text-center" /* Ajout de text-center pour centrer le texte */
                style={{
                    backgroundColor: statusColor,
                    color: textColor,
                    borderColor: statusColor,
                    borderLeft: `5px solid ${statusColor}`,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                {/* Centrer le contenu avec des classes flex */}
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-1" style={{ fontWeight: 'bold' }}>{statusName}</h5>
                    {statusDescription && (
                        <div className="small" style={{ opacity: 0.9 }}>
                            {statusDescription}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TrackingHeader;